import { Box } from '@chakra-ui/react';
import type { ReactElement } from 'react';

import type { NavItemConfig } from '@revelio/auth';

const isReactIcon = (icon: NavItemConfig['icon']): icon is ReactElement =>
  Boolean(icon) && typeof icon !== 'string';

export const navIconBg = (icon: NavItemConfig['icon']) =>
  typeof icon === 'string' ? `url(${icon})` : undefined;

export const NavIconChild = ({ icon }: { icon: NavItemConfig['icon'] }) =>
  isReactIcon(icon) ? (
    <Box
      position="absolute"
      top="8px"
      left="8px"
      w="24px"
      h="24px"
      color="white"
      pointerEvents="none"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      {icon}
    </Box>
  ) : null;
